<div class="release-notes hidden">
  <h1 class="ui-heading-1-bold release-notes-title">
    {{ knowledgeSection() }}
  </h1>

  <div class="release-notes-content">
    @for(r of releaseNotes(); track $index) {
      @if(r.published === true) {
      <div class="release-notes-item">
        <h3 class="ui-heading-3 release-notes-name">
          {{ r.header }}
        </h3>
        <p class="ui-label-m-bold">{{ r.subheader }}</p>
        <p class="ui-label-m-bold low-contrast">
          {{ r.date | date : "yyyy-MM-dd" }}
        </p>
        <div class="ui-body-m release-notes-description" [innerHTML]="r?.description | safeHtml"></div>
        <a rds-link standalone href="{{ r.url }}" target="_blank">
          {{ r.url }}
          <rds-icon namespace="filled" icon="arrow_right" />
        </a>
      </div>
      }
    }
  </div>
</div>
